<template>
    <div>
        <div :style="{width:`${progress}vw`}"></div>
    </div>
    <!--<div :style="{width:`100vw`}"></div>-->
</template>

<script>
    export default {
        name: "ProgressBar",
        props: ['progress']
    }
</script>

<style scoped>
    div {
        height: 2px;
        background-color: rgba(255, 255, 255, 0.8);
    }
</style>